




































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Tooltip } from 'ant-design-vue'
import { delCourse } from './data'
import { ListType, ItemData, ItemType } from '@/util/types'
import { devLog } from '@/util/dev'
import { iconMap } from '@/util/resMap'

@Component({
  components: {
    Tooltip
  }
})
export default class Item extends Vue {
  @Prop({ type: Object, default: () => ({}) }) data!: ItemData
  @Prop({ type: Number, default: 10 }) type!: number
  @Prop({ type: Boolean, default: false }) isCreatePage!: boolean

  goEditvisible = false

  iconMap = iconMap

  gotoPlayVisible: boolean = false

  enter() {
    this.goEditvisible = true
  }

  leave() {
    this.goEditvisible = false
  }
  // 是否课程
  get isCourse() {
    return this.data.type == ItemType.course
  }
  // 是否课件
  get isResource() {
    return this.data.type == ItemType.resource
  }

  // 是否是我的课程
  get isMyCourse() {
    return this.type == ListType.myCourse
  }
  get detailRoute() {
    const { id } = this.data
    return {
      name: this.isCourse ? 'courseDetail' : 'resourceDetail',
      params: { id, type: this.type == 10 ? 0 : 1 }
    }
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  async delCourse(row: ItemData) {
    const that = this

    that.$emit('delclick', row)
    // this.$confirm({
    //   title: this.i18n.vCourse.delHints,
    //   content: '',
    //   onCancel() {},
    //   onOk() {
    //     that.$emit('delclick', row)
    //   }
    // })
  }
  // 手动控制去上课提示的显示隐藏
  mouseenter() {
    this.gotoPlayVisible = true
  }

  mouseleave() {
    this.gotoPlayVisible = false
  }
  goPlay(row: any) {
    this.gotoPlayVisible = false
    this.$store.commit('setPlayList', row.res_list)
    const type = this.type == 10 ? 0 : 1
    // 0 云端课程 1本地课程
    const all = Object.assign({}, row, { alltype: type })
    // console.log(all)
    this.$store.commit('setplayALL', all)
    this.$router.push({
      name: 'playIndex',
      params: {
        id: row.id + ''
      }
    })
  }

  goEdit(row: any) {
    this.goEditvisible = false
    this.$store.commit('setPlayList', row.res_list)
    this.$router.push({
      name: 'courseEdit'
      // params: { id: row.id, type: (this.type == 10 ? 0 : 1) + '' }
    })
  }

  addItem(row: any) {
    const addList: any[] = this.getAddedItem(row) || []
    const playList = this.$store.state.playList
    if (addList.length == 0) {
      this.$message.warning(this.i18n.vResItem.added)
    } else {
      this.$store.commit('setPlayList', [...playList, ...addList])
    }
  }

  getAddedItem(row: any) {
    // 处理添加课程的情况
    const playList = this.$store.state.playList
    if (row.res_list) {
      const resList = row.res_list.filter(
        (elem: any) => !playList.find((ele: any) => ele.id === elem.id)
      )
      return [...resList]
    }
    if (!playList.find((ele: any) => ele.id === row.id)) {
      return [row]
    }
  }

  // 点击事件,我的课程：点击直接进入课堂
  itemClick(data: any, detailRoute: any) {
    if (this.isMyCourse) {
      this.goPlay(data)
      return
    }
    this.$router.push(detailRoute)
  }
}
